import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import NavHeader from '../NavHeader';
import CheckoutSummaryHeader from '../CheckoutSummaryHeader';
import SeriesPanel from '../SeriesPanel';
import Loading from 'components/Loading';

const text = {
  emptyCartMessage: 'Your cart is empty.',
  showMore: 'Show more',
};

export const Cart = ({
  cartIsEmpty,
  cartLoading,
  cartSubmissionLoading,
  hasRemaining,
  seriesIds,
  submitting,
  moreCart,
}) => (
  <div className={styles.cartDashboard}>
    <NavHeader />
    <CheckoutSummaryHeader />
    {cartSubmissionLoading ? (
      <div className={styles.submitting}>{submitting}</div>
    ) : (
      <div>
        {seriesIds.map(seriesId => (
          <SeriesPanel key={seriesId} seriesId={seriesId} />
        ))}
        {hasRemaining && (
          <div className={styles.showMore} onClick={moreCart}>
            {text.showMore}
          </div>
        )}
      </div>
    )}
    {cartIsEmpty && (
      <div className={styles.emptyCart}>{text.emptyCartMessage}</div>
    )}
    {cartLoading && <Loading />}
  </div>
);

Cart.propTypes = {
  cartIsEmpty: PropTypes.bool.isRequired,
  cartLoading: PropTypes.bool.isRequired,
  cartSubmissionLoading: PropTypes.bool.isRequired,
  seriesIds: PropTypes.array.isRequired,
  submitting: PropTypes.string.isRequired,
};

export default enhance(Cart);
